import React, { useEffect, useState } from 'react';

export default function ImagePreviewStrip({ images, title, onRemove }) {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    const next = images.map((file) => ({ file, url: URL.createObjectURL(file) }));
    setItems(next);
    return () => next.forEach((item) => URL.revokeObjectURL(item.url));
  }, [images]);

  if (!items.length) return null;
  return (
    <>
      <div className="mv-image-strip">
        {title && <strong>{title}</strong>}
        <div className="mv-image-strip__grid">
          {items.map((item, index) => (
            <div className="mv-image-thumb" key={`${item.file.name}-${index}`}>
              <button className="mv-image-thumb__preview" onClick={() => setActive(item)}>
                <img src={item.url} alt={item.file.name || `MV image ${index + 1}`} />
              </button>
              {onRemove && <button className="mv-image-thumb__remove" onClick={() => onRemove(index)}>×</button>}
            </div>
          ))}
        </div>
      </div>
      {active && (
        <button className="mv-image-lightbox" onClick={() => setActive(null)}>
          <img src={active.url} alt={active.file.name || 'MV image preview'} />
        </button>
      )}
    </>
  );
}
